const contentGetters = {
  getMessages: (state) => state.messages,
  getMessage: (state) => state.message,
  getThreads: (state) => state.threads,
  getThreadsBySlug: (state) => state.threadsBySlug,
  getThreadsUsers: (state) => state.threadsUsers,
  getNewsFeed: (state) => state.newsFeed,
  getNewsFeeds: (state) => state.newsFeeds,
  getSurveys: (state) => state.surveys,
  getSurveysActivated: (state) => state.surveysActivated,
  getSurvey: (state) => state.survey,
  getSurveyGroups: (state) => state.survey_groups
}

export { contentGetters }
